/**
 * 银行的枚举
 */
export const bankNames = [
  '中国人民银行',
  '中国工商银行',
  '中国农业银行',
  '中国银行',
  '中国建设银行',
  '国家开发银行',
  '中国进出口银行',
  '中国农业发展银行',
  '交通银行',
  '中信银行',
  '中国光大银行',
  '华夏银行',
  '中国民生银行',
  '广发银行',
  '平安银行',
  '招商银行',
  '兴业银行',
  '上海浦东发展银行',
  '北京银行',
  '天津滨海农村商业银行',
  '恒丰银行',
  '浙商银行',
  '天津东丽农村合作银行',
  '渤海银行',
  '徽商银行',
  '北京延庆村镇银行',
  '重庆三峡银行',
  '宁夏中宁青银村镇银行',
  '天津金城银行',
  '上海银行',
  '邯郸市城市信用社',
  '沈阳农村商业银行',
  '中国邮政储蓄银行',
  '汇丰银行',
  '东亚银行',
  '南洋商业银行',
  '恒生银行',
  '集友银行',
  '创兴银行',
  '大众银行',
  '永亨银行',
  '上海商业银行',
  '永隆银行',
  '大新银行',
  '华南商业银行',
  '彰化商业银行',
  '国泰世华商业银行',
  '合作金库商业银行',
  '第一商业银行',
  '台湾土地银行',
  '兆丰国际商业银行',
  '台湾银行',
  '玉山银行',
  '花旗银行',
  '美国银行',
  '摩根大通银行',
  '美国建东银行',
  '三菱东京日联银行',
  '日本日联银行',
  '三井住友银行',
  '瑞穗银行',
  '日本山口银行',
  '日本三井住友信托银行',
  '日本横滨银行',
  '外换银行',
  '韩国新韩银行',
  '友利银行',
  '韩国产业银行',
  '新韩银行',
  '企业银行',
  '国民银行',
  '中国信托商业银行',
  '马来西亚马来亚银行',
  '首都银行',
  '华侨银行',
  '大华银行',
  '星展银行',
  '盘谷银行',
  '泰国开泰银行',
  '奥地利奥合国际银行',
  '比利时联合银行',
  '比利时富通银行',
  '苏格兰皇家银行',
  '荷兰安智银行',
  '渣打银行',
  '英国苏格兰皇家银行',
  '英国巴克莱银行',
  '瑞典商业银行',
  '瑞典北欧斯安银行',
  '瑞典银行',
  '法国兴业银行',
  '法国巴黎银行',
  '法国东方汇理银行',
  '东方汇理银行',
  '法国外贸银行',
  '德国德累斯登银行',
  '德意志银行',
  '德国商业银行',
  '德国宝缔纲银行',
  '德国巴伐利亚州银行',
  '德国北德意志州银行',
  '中德住房储蓄银行',
  '意大利裕信银行',
  '意大利联合圣保罗银行',
  '瑞士信贷银行',
  '瑞士银行',
  '加拿大丰业银行',
  '蒙特利尔银行',
  '澳大利亚和新西兰银行',
  '澳大利亚西太平洋银行',
  '俄罗斯外贸银行',
  '摩根士丹利国际银行',
  '华美银行',
  '荷兰合作银行',
  '厦门国际银行',
  '华商银行',
  '韩亚银行',
  '富邦华一银行',
];



// WEBPACK FOOTER //
// ./src/utils/enum/bank-enum.js